module.exports = __webpack_public_path__ + "media/images/icon_a6_blue-d4cce32c399783e7cc59048a84d601ef.png";